var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Easing"}},[_c('v-select',{attrs:{"options":_vm.options,"searchable":false,"reduce":val => val.value},model:{value:(_vm.easing),callback:function ($$v) {_vm.easing=$$v},expression:"easing"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }